module.exports = __webpack_public_path__ + "static/media/curry-vegetarien.a82ae164.png";